import React, { useState } from "react";
import Select from "react-select";
import cn from "classnames";
import style from "./index.module.scss";
import "./select-custom.scss";
import {t} from "i18next";

const CLASS_NAMES = {
  name: "select-custom-wrapper",
  root: "custom-select",
};

const CustomSelectMulti = ({
  placeholder = t('common.placeholder.selectOption'),
  keyId = "id",
  keyName = "name",
  isDisabled = false,
  options = [],
  onSubmit,
  bgGray = false,
  isMulti = false,
  defaultValue = [],
  labelText = "",
  errorText = "",
}) => {
  const [selectedOptions, setSelectedOptions] = useState(defaultValue);

  const onOptionChangeHandler = (selected) => {
    if (selected.some((opt) => opt[keyId] === "selectAll")) {
      if (selectedOptions.length === options.length) {
        setSelectedOptions([]);
        onSubmit([]);
      } else {
        setSelectedOptions(options);
        onSubmit(options);
      }
    } else {
      setSelectedOptions(selected);
      onSubmit(selected);
    }
  };

  const enhancedOptions = [
    { [keyId]: "selectAll", [keyName]: t('chooseAll') },
    ...options,
  ];

  const isOptionSelected = (option) =>
    selectedOptions.some((selected) => selected[keyId] === option[keyId]);

  return (
    <div
      className={cn(CLASS_NAMES.root, style.select_control, {
        [CLASS_NAMES.root + "__bgGray"]: bgGray,
      })}
    >
      <label
        className={cn(style.labelInp, {
          [style.focusedLabel]: selectedOptions.length > 0,
          [style.labelError]: errorText,
        })}
      >
        {labelText}
      </label>
      <Select
        value={selectedOptions}
        onChange={onOptionChangeHandler}
        placeholder={placeholder}
        className={cn(CLASS_NAMES.name, {
          [style.input_errorState]: errorText,
          [CLASS_NAMES.name + "__isMulti"]: isMulti,
        })}
        classNamePrefix={CLASS_NAMES.name + "__content"}
        getOptionLabel={(option) => (
          <div className={style.optionLabel}>
            <input
              type="checkbox"
              checked={isOptionSelected(option)}
              onChange={() => {}}
              className={style.checkbox}
            />
            <span>{option[keyName]}</span>
          </div>
        )}
        getOptionValue={(option) => option[keyId]}
        options={enhancedOptions}
        isMulti={isMulti}
        isDisabled={isDisabled}
        closeMenuOnSelect={false}
        hideSelectedOptions={false}
      />
      {errorText && <div className={style.errorText}>{errorText}</div>}
    </div>
  );
};

export default CustomSelectMulti;
